module.exports = __webpack_public_path__ + "static/media/moli.ff670459.jpg";